import { Conversation } from 'generated-graphql/types';
import {
  ControlFilter,
  ConversationFilterIds,
  ConversationStatusFilter
} from '../constants/enums';
import { getConversationStatusFilter } from './getConversationStatusFilter';

export const getFilteredConversations = (
  filter:
    | { value: string | boolean; filterId: ConversationFilterIds }
    | undefined,
  conversations: Conversation[]
) => {
  if (!filter) {
    return conversations;
  }

  const { filterId, value } = filter;

  return conversations.filter((conversation) => {
    if (filterId === ConversationFilterIds.status) {
      return getConversationStatusFilter(
        value as ConversationStatusFilter,
        conversation
      );
    }

    if (filterId === ConversationFilterIds.applicationStage) {
      return conversation.applicationStage === value;
    }

    if (filterId === ConversationFilterIds.screeningStatus) {
      return conversation.status === value;
    }

    if (filterId === ConversationFilterIds.control) {
      if (value === ControlFilter.AI) {
        return !conversation.isHumanTakeover;
      }

      if (value === ControlFilter.MANUAL) {
        return conversation.isHumanTakeover;
      }
    }

    return true;
  });
};
